/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import { SketchPicker } from 'react-color'; // can use a number of different style pickers with this module (check the link below for more options)
// using a package here, in the essence of time saving
// http://casesandberg.github.io/react-color/
// material
import { Button, TextField } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/colorpicker/colorpicker_styles';



/* ========== ~~~~~~~~~~ EMBED : COLOR PICKER ~~~~~~~~~~ ========== */
class ColorPicker extends Component {
	constructor(props) {
		super(props);
		this.storedColor = this.props.color ? this.props.color : '#cccccc';
		this.state = { picker: 'inactive' };
	}
	handleFieldFocus = (e) => {
		e.target.select();
		document.execCommand('copy');
	}
	handleChangeComplete = (color) => {
		//this.storedColor = color.hex;
		this.storedColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
		this.props.processColorUpdate(this.storedColor);
	}
	displayColorPicker = () => {
		document.addEventListener('mousedown', this.handleOutsideClick, false);
		this.setState({ picker: 'active' });
	}
	closeColorPicker = () => {
		this.props.processColorUpdate(this.storedColor);
		this.setState({ picker: 'inactive' });
		document.removeEventListener('mousedown', this.handleOutsideClick, false);
	}
	handleOutsideClick = (e) => {
		// ignore clicks on the component itself
		if (this.node.contains(e.target)) { return; }
		this.closeColorPicker();
	}
	render() {
		const color = !this.props.color ? this.storedColor : this.props.color;
		return (
			<div className={`colorpicker ${this.props.classes.colorpicker}`}>
				<div className={`currentcolor`}>
					<span className={`swatch`} style={{ background: color }} onClick={this.displayColorPicker} />
					<TextField klass={'colortext'} type={`text`} name={`code`} value={color} onFocus={this.handleFieldFocus} readOnly />
				</div>
				<div className={`picker ${this.state.picker}`} ref={node => { this.node = node; }}>
					<SketchPicker color={color} onChangeComplete={this.handleChangeComplete} />
					<Button type={`custom`} handleClick={this.closeColorPicker} variant={`primary`} name={`close`} text={`Apply Color`} />
				</div>
			</div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ColorPicker);
